<template>
  <div style="height: 100%">

    <!-- <b-dropdown size="sm" split text="AC Test" right variant="dark" class="m-2" v-if="is_editable"> -->
    <!-- <b-dropdown size="sm" split text="AC Test" right variant="dark" class="m-2">
      <b-dropdown-item @click="modal_show('modal-ac-test-generate-entry-populated')">
        <div class="icon-pencil-cs"></div>
        <span>New Punch Item</span>
      </b-dropdown-item>
    </b-dropdown> -->

    <button type="button" @click="modal_show('modal-punch-item-entry', true)" class="btn btn-primary btn-sm m-3" v-if="is_editable_qaqc">New Punch Item</button>

    <!-- :gridOptions="gridOptions" @selection-changed="onSelectionChanged" -->
    <!-- <ag-grid-vue style="width: 100%; height: 600px;" class="flex-grow-1 flex-shrink-1 ag-theme-alpine"
      :suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="columnDefs" rowSelection="multiple"
      :rowData="rowData" @grid-ready="onGridReady"></ag-grid-vue> -->
    <ag-grid-vue style="width: 100%; height: 90%;" class="flex-grow-1 flex-shrink-1 ag-theme-alpine"
      :suppressRowClickSelection="true" rowSelection="multiple"
			:defaultColDef="defaultColDef" 
			:gridOptions="oGrid.gridOptions_punch_item"
      :rowData="rowData" 
			@grid-ready="onGridReady">
		</ag-grid-vue>

    <!-- modal punch item entry -->
    <b-modal ref="modal-punch-item-entry" size="xl" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row class="modal-row-header">
          <b-col>
            <div style="float: left;" class="text-white h3">Punch Item Entry</div>
            <div style="float: right;">
              <base-button v-if="is_approval_qaqc" type="btn btn-sm base-button btn-primary" @click="approval_process()">Approval</base-button>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!-- tabs -->
            <b-tabs content-class="mt-3" justified>
              <!-- QAQC - main item information -->
              <b-tab no-body title="QAQC Punch Item Entry">
                <!-- punch item main information -->
                <b-row>
                  <b-col class="mb-2" md="12" lg="4" xl="4" style="display: none;">
                    <label for="" class="text-white">S/N </label>
                    <b-form-input type="number" step="1" min="1" placeholder="" v-model="oModel.qaqc_item_update.sn"></b-form-input>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="12" xl="12">
                    <label for="" class="text-white">Description </label>
                    <b-form-input placeholder="" v-model="oModel.qaqc_item_update.description"></b-form-input>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="4" xl="4">
                    <label for="" class="text-white">Cat (A/B)</label>
                    <select class="form-control" v-model="oModel.qaqc_item_update.cat_id" @change="selected_cat_ab()">
                      <option v-for="item in oField.dd_cat_a_b" :key="item.key" v-bind:value="item.key">{{ item.value }}
                      </option>
                    </select>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="4" xl="4">
                    <label for="" class="text-white">Infrastructure Category</label>
                    <select class="form-control" v-model="oModel.qaqc_item_update.infra_cat_id" @change="selected_dd_category()">
                      <option v-for="item in oField.dd_infra_category" :key="item.key" v-bind:value="item.key">{{ item.value }}
                      </option>
                    </select>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="4" xl="4">
                    <label for="" class="text-white">Infrastructure Sub Category</label>
                    <select class="form-control" v-model="oModel.qaqc_item_update.infra_sub_cat_id">
                      <option v-for="item in oField.dd_infra_sub_category" :key="item.key" v-bind:value="item.key">{{ item.value }}
                      </option>
                    </select>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="4" xl="4">
                    <label for="" class="text-white">Failure Mode</label>
                    <select class="form-control" v-model="oModel.qaqc_item_update.failure_mode_id">
                      <option v-for="item in oField.dd_failure_mode" :key="item.key" v-bind:value="item.key">{{ item.value }}
                      </option>
                    </select>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="8" xl="8">
                    <label for="" class="text-white">Remarks</label>
                    <b-form-input placeholder="" v-model="oModel.qaqc_item_update.remarks"></b-form-input>
                  </b-col>
                </b-row>
                
                <!-- punch item side note -->
                <b-row>
                  <b-col class="mb-0" md="12" lg="12" xl="12">
                    <span class="punch_item_note">** Punch List Category "A": To be completed before Testing & Commisioning.</span>
                  </b-col>
                  <b-col class="mb-0" md="12" lg="12" xl="12">
                    <span class="punch_item_note">** Punch List Category "B": To be completed before Provisional Acceptance or issuance of job Completion.</span>
                  </b-col>
                </b-row>

                <hr class="hr" />

                <!-- container images / photos -->
                <b-row>
                  <!-- button add photo -->
                  <b-col class="mb-2" md="12" lg="12" xl="12">
                    <!-- <label for="" class="text-white">Add Photos</label> -->
                    <input
                      v-show="false"
                      type="file"
                      id="imageFile_QAQC"
                      ref="imageFile_QAQC"
                      accept="image/jpeg, image/png, image/gif, image/webp"
                      v-on:change="handleImageFileUpload_QAQC()"
                    />
                    <!-- <base-button v-if="oModel.qaqc_images.length <= 2" size="sm" type="primary" @click="$refs.imageFile_QAQC.click()">Add Photo</base-button> -->
                    <base-button v-if="is_max_images_qaqc" size="sm" type="primary" @click="$refs.imageFile_QAQC.click()">Add Photo</base-button>
                  </b-col>
                  
                  <b-col class="mb-2" md="12" lg="12" xl="12">
                    <b-row>
											<!-- display added new images -->
                      <div v-for="(item, index) in oModel.qaqc_images" :key="index">
                        <!-- <card> -->
                          <b-col md="4">
                            <img
                              :src="item.photoPreviewSrc"
                              style="max-width:250px;max-height:250px;"
                              v-if="item.photoFile"
                            >
                            <base-button v-if="is_editable_qaqc" size="sm" type="danger" @click="deletePhoto_QAQC(index)" style="margin-top: 10px;">Delete</base-button>
                          </b-col>
                        <!-- </card> -->
                      </div>
											<!-- display saved images in db -->
											<div v-for="(item, index) in oModel.qaqc_item_update.qaqc_images" :key="index">
                        <!-- <card> -->
                          <b-col md="4">
                            <img
                              :src="item.imageDataSrc"
                              style="max-width:250px;max-height:250px;"
                 							@click="showLargeImage(item.imageDataSrc)"
                            >
                            <base-button v-if="is_editable_qaqc" size="sm" type="danger" @click="deletePhoto_from_db('confirmation', 'qaqc', item.id, index)" style="margin-top: 10px;">Delete</base-button>
                          </b-col>
                        <!-- </card> -->
                      </div>
                    </b-row>
                  </b-col>
                </b-row>

                <hr class="hr" />

                <!-- consent by QAQC -->
                <b-row>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label for="" class="text-white">Date Generated </label>
                    <!-- <b-form-input placeholder="" v-model="oModel.qaqc_item_update.date_generated" disabled></b-form-input> -->
                    <base-input name="Date" type="date" v-model="oModel.qaqc_item_update.date_generated" disabled></base-input>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label for="" class="text-white">E-Signature </label>
                    <b-form-input placeholder="" v-model="oModel.qaqc_item_update.qaqc_name" disabled></b-form-input>
                    <input type="checkbox" id="checkbox" v-model="oModel.qaqc_item_update.qaqc_acknowledge"> <span class="punch_item_consent">By selecting this checkbox, you acknowledge and consent to electronically sign and approve this section.</span>
                  </b-col>
                </b-row>


                <!-- <b-card-footer style="float: right;" v-if="is_editable"> -->
                <b-card-footer style="float: right;">
                  <base-button type="btn btn-sm base-button btn-success" outline @click="modal_close('modal-punch-item-entry')">Cancel</base-button>
                  <base-button v-if="is_editable_qaqc" type="btn btn-sm base-button btn-primary" @click="update_punch_item_by_qaqc()">Save</base-button>
                </b-card-footer>
              </b-tab>

              <!-- CONTRACTOR - rectification by contractor -->
              <b-tab no-body title="Rectification by Contractor">
                <!-- approval information -->
                <b-row v-if="oModel.qaqc_item_update.status != 'PENDING'">
                  <b-col class="mb-2" md="12" lg="12" xl="12">
                    <label for="" class="text-white">Status: {{ oModel.qaqc_item_update.status}}</label>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="12" xl="12" v-if="oModel.qaqc_item_update.status == 'REJECTED'">
                    <label for="" class="text-white">Remarks: {{ oModel.qaqc_item_update.reject_remarks}}</label>
                  </b-col>
                </b-row>
                <hr class="hr" v-if="oModel.qaqc_item_update.status != 'PENDING'"/>

                <!-- container images / photos -->
                <b-row>
                  <!-- button add photo -->
                  <b-col class="mb-2" md="12" lg="12" xl="12">
                    <!-- <label for="" class="text-white">Add Photos</label> -->
                    <input
                      v-show="false"
                      type="file"
                      id="imageFile_contractor"
                      ref="imageFile_contractor"
                      accept="image/jpeg, image/png, image/gif, image/webp"
                      v-on:change="handleImageFileUpload_contractor()"
                    />
                    <!-- <base-button v-if="oModel.qaqc_images.length <= 2" size="sm" type="primary" @click="$refs.imageFile_contractor.click()">Add Photo</base-button> -->
                    <base-button v-if="is_max_images_contractor" size="sm" type="primary" @click="$refs.imageFile_contractor.click()">Add Photo</base-button>
                  </b-col>
                  
                  <b-col class="mb-2" md="12" lg="12" xl="12">
                    <b-row>
											<!-- display added new images -->
                      <div v-for="(item, index) in oModel.contractor_images" :key="index">
                        <!-- <card> -->
                          <b-col md="4">
                            <img
                              :src="item.photoPreviewSrc"
                              style="max-width:250px;max-height:250px;"
                              v-if="item.photoFile"
                            >
                            <base-button v-if="is_editable_epc" size="sm" type="danger" @click="deletePhoto_contractor(index)" style="margin-top: 10px;">Delete</base-button>
                          </b-col>
                        <!-- </card> -->
                      </div>
											<!-- display saved images in db -->
											<div v-for="(item, index) in oModel.qaqc_item_update.contractor_images" :key="index">
                        <!-- <card> -->
                          <b-col md="4">
                            <img
                              :src="item.imageDataSrc"
                              style="max-width:250px;max-height:250px;"
                 							@click="showLargeImage(item.imageDataSrc)"
                            >
                            <base-button v-if="is_editable_epc" size="sm" type="danger" @click="deletePhoto_from_db('confirmation', 'contractor', item.id, index)" style="margin-top: 10px;">Delete</base-button>
                          </b-col>
                        <!-- </card> -->
                      </div>
                    </b-row>
                  </b-col>
                </b-row>

                <hr class="hr" />

                <!-- consent by QAQC -->
                <b-row>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label for="" class="text-white">Completion Date</label>
                    <!-- <b-form-input type="data" placeholder="" v-model="oModel.qaqc_item_update.date_completion"></b-form-input> -->
                    <base-input name="Date" type="date" v-model="oModel.qaqc_item_update.date_completion"></base-input>
                  </b-col>
                  <b-col class="mb-2" md="12" lg="6" xl="6">
                    <label for="" class="text-white">E-Signature </label>
                    <b-form-input placeholder="" v-model="oModel.qaqc_item_update.contractor_name" disabled></b-form-input>
                    <input type="checkbox" id="checkbox" v-model="oModel.qaqc_item_update.contractor_acknowledge"> <span class="punch_item_consent">By selecting this checkbox, you acknowledge and consent to electronically sign and approve this section.</span>
                  </b-col>
                </b-row>

                <!-- <b-card-footer style="float: right;" v-if="is_editable"> -->
                <b-card-footer style="float: right;">
                  <base-button type="btn btn-sm base-button btn-success" outline @click="modal_close('modal-punch-item-entry')">Cancel</base-button>
                  <!-- <base-button @click="batch_process_add_ac_test_entry()" type="primary">Save Main Meter</base-button> -->
                  <base-button v-if="is_editable_epc" type="btn btn-sm base-button btn-primary" @click="update_rectification_by_contractor()">Save</base-button>
                </b-card-footer>
              </b-tab>    

            </b-tabs>            
          </b-col>
        </b-row>

      </div>
    </b-modal>

    <!-- Modal loading / in progress -->
    <!-- <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="" :no-close-on-backdrop="true"> -->
    <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- date | time | project name | site name -->
        <b-row class="mb-3">
          <b-col>
            <div class="text-center text-muted mb-4">
              <h1 class="text-white"><b>Loading in progress</b></h1>
            </div>
            <div class="text-center">
              <div style="color: #ffffff;">
                <!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
                <span class="icon-spinner-cs"></span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- Modal show large image -->
		<modal :show.sync="oModal.is_visible_large_img" size="xl" body-classes="p-0" title="Image">
      <card type="secondary" header-classes="bg-transparent pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
				<div class="text-center">
					<img :src="oModal.src_large_img" style = "max-width:100%;">
				</div>
      </card>
    </modal>

    <!-- approval -->
    <b-modal ref="modal-punch-item-approval" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- <b-row class="modal-row-header">
          <b-col>
            <div class="text-white h3"># of AC Test entry</div>
          </b-col>
        </b-row> -->

        <!-- desc observation -->
        <b-row>
          <b-col>
            <label for="" class="text-white">Remarks </label>
            <b-form-input v-model="oModel.approval.remarks" placeholder="Approve not requires remark"></b-form-input>
          </b-col>
        </b-row>
        <b-row style="padding-top: 20px;" v-if="is_approval_qaqc">
          <b-col class="">
            <base-button type="success" @click="modal_close('modal-punch-item-approval')">Cancel</base-button>
          </b-col>
          <b-col class="text-right">
            <base-button @click="approval_execute('approve')" type="success">Approve</base-button>
            <base-button @click="approval_execute('reject')" type="danger">Reject</base-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- confirmation -->
    <b-modal ref="modal-confirmation" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row>
          <b-col>
            <div class="text-center text-muted mb-4">
              <h2 class="text-white"><b>{{ oModal.confirmation_img_deletion.message }}</b></h2>
            </div>
          </b-col>
        </b-row>
        <b-row style="padding-top: 20px;">
          <b-col md="6" lg="6" xl="6">
            <div class="text-center text-muted mb-4">
              <base-button @click="deletePhoto_from_db('confirm' ,oModal.confirmation_img_deletion.image_src, oModal.confirmation_img_deletion.image_id, oModal.confirmation_img_deletion.image_idx)" type="danger">Confirm</base-button>
            </div>
          </b-col>
          
          <b-col md="6" lg="6" xl="6">
            <div class="text-center text-muted mb-4">
              <base-button @click="deletePhoto_from_db('cancel' ,oModal.confirmation_img_deletion.image_src, oModal.confirmation_img_deletion.image_id, oModal.confirmation_img_deletion.image_idx)" type="success">Cancel</base-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>


<script>
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";

// import axios from "axios";
import axios from '@/util/axios'

import { AgGridVue } from "@ag-grid-community/vue";
import '@ag-grid-enterprise/core';
import HeaderGroupComponent from './HeaderGroupComponent.vue';
import btnEditPunchItem from './gridBtn_edit_punch_item.vue';

import { isEmpty, cloneDeep } from "lodash";
import moment from "moment";
import jsonFormData from 'json-form-data';

export default {
  props: ['shareData', 'subData'],
  mixins: [ErrorFunctionMixin, CustomLibHelper],
  components: {
    'ag-grid-vue': AgGridVue,
		HeaderGroupComponent,
    btnEditPunchItem,
  },
  data() {
    return {
      oDev: {
        debug: true,
      },
      oField: {
        id_punch_item: null,
        dd_cat_a_b: [
          { key: '', value: '-- please select --' },
          { key: '1', value: 'A' },
          { key: '2', value: 'B' },
        ],        
        dd_infra_category: [
          { key: '', value: '-- loading --' },
        ], 
        dd_infra_sub_category: [
          { key: '', value: '-- please select category --' },
        ], 
        dd_failure_mode: [
          { key: '', value: '-- loading --' },
        ], 
      },
			oModal: {
				src_large_img: null,
				is_visible_large_img: false,
        confirmation_img_deletion: {
          message: 'Are you sure you want to delete this photo?',
          image_src: '',
          image_id: '',
          image_idx: '',
        },
			},
      gridApi: null,
      rowData: null,
			oGrid: {
        gridOptions_punch_item: null,
				// api_pve: null,
        // columnDefs_pv_inverter: null,
        // detailCellRendererParams_pv_string: null,
        selected: {
          punch_item: null,
        }
      },
      defaultColDef: {
        flex: 1,
        minWidth: 100,
      },
      oModel: {
        qaqc_item_update: {
					id: null,
          sn: 1,
          description: '',
          cat_id: '',
          cat: '',
          infra_cat_id: '',
          infra_sub_cat_id: '',
          failure_mode_id: '',
          // cat: '',
          // infra_cat: '',
          // infra_sub_cat: '',
          // failure_mode: '',
          remarks: '',
          date_generated: '',
          qaqc_name: '',
					qaqc_images: [],
          qaqc_acknowledge: 0,
					date_completion: '',
					contractor_name: '',
          contractor_images: [],
					contractor_acknowledge: '',
          status: '',
          reject_remarks: '',
        },
        qaqc_images: [],

        contractor_images: [],
        approval: {
          remarks: '',
        },
      },
      //_ unused

    }
  },
  computed: {
    is_editable_qaqc() {
      return this.shareData.is_qaqc && !this.shareData.is_acknowledge_by_onm;
    },
    is_approval_qaqc() {
      return this.shareData.is_qaqc && this.oModel.qaqc_item_update.contractor_acknowledge && !this.shareData.is_acknowledge_by_onm && ( this.oModel.qaqc_item_update.status == 'PENDING' || this.oModel.qaqc_item_update.status == 'REJECTED' );
    },
    is_editable_onm() {
      return this.shareData.is_onm && !this.shareData.is_acknowledge_by_onm;
    },
    is_editable_epc() {
      return this.shareData.is_epc && !this.shareData.is_acknowledge_by_onm;
      //  && this.shareData.status_tnc != 'APPROVED'
    },
		is_max_images_qaqc() {
			let image_db = this.oModel.qaqc_item_update.qaqc_images.length;
			let image_ui = this.oModel.qaqc_images.length;
			let iCount_images = image_db + image_ui;
      let bShowImages = ((iCount_images) >= 3) ? false : true

			return this.shareData.is_qaqc && bShowImages && !this.shareData.is_acknowledge_by_onm;
		},
    is_max_images_contractor() {
			let image_db = this.oModel.qaqc_item_update.contractor_images.length;
			let image_ui = this.oModel.contractor_images.length;
			let iCount_images = image_db + image_ui;
      let bShowImages = ((iCount_images) >= 3) ? false : true

			return this.shareData.is_epc && bShowImages && !this.shareData.is_acknowledge_by_onm;
		},
  },
	watch:{
		subData(){
      //_ don't know why the subData not reactive, so we need to put it inside watch, so that everytime there is an update, the grid reload with the new data.
			// this.devMsg(this.oDev.debug, 'watch subData()', 'gs')
			// console.log('this.shareData')
			// console.log(this.shareData)

			// console.log('this.subData')
			// console.log(this.subData)

			this.gridApi.updateGridOptions({ rowData: this.subData });			
			// this.devMsg(this.oDev.debug, '', 'ge')
		}
	},
  created() {
  },
  mounted() {
    //_ populated dropdown list
    this.populate_dd_category();
    this.populate_dd_failure_mode();
		
    // this.oModel.qaqc_item_update.contractor_name = this.shareData.user.name;
  },
  beforeMount() {
		this.grid_construct_gridOptions_punch_item();
  },	
  methods: {
    onGridReady(params) {
      this.devMsg(this.oDev.debug, 'onGridReady - punch item', 'gs')

			this.devMsg(this.oDev.debug, this.subData)
      // this.gridApi.value = params.api;

      this.gridApi = params.api;
      // this.gridApi.sizeColumnsToFit();
      // this.gridApi.autoSizeAllColumns({skipHeader: true});

      // fetch('https://www.ag-grid.com/example-assets/small-olympic-winners.json')
      //   .then((response) => response.json())
      //   .then(function (data) {
      //     params.api.updateGridOptions({ rowData: data });
      //   });

      params.api.updateGridOptions({ 
        rowData: this.subData,
        // autoSizeStrategy: {
        //   type: 'fitCellContents'
        // },
       });

      if (this.subData.length > 0) {
        this.oField.id_punch_item = this.subData[0].id
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },
		grid_construct_gridOptions_punch_item() {
      this.oGrid.gridOptions_punch_item = {
				columnDefs: [
					{
						headerName: 'Actions', field: 'actions', headerClass: 'ag-center-content',
            cellStyle: {'display': 'flex', 'align-items': 'center'},
						cellRenderer: 'btnEditPunchItem',
						cellRendererParams: {
							actionEdit: this.edit_selected_punch_item.bind(this) // this is your parent component function
						},
						minWidth: 30,
					},					
					// {
					// 	headerName: '', minWidth: 60, width: 60, headerCheckboxSelection: true, checkboxSelection: true, sortable: false,
					// 	headerClass: '', pinned: true, suppressHeaderMenuButton: true,
					// 	cellClass: ''
					// },
					{
						headerName: 'S/N',
						headerClass: 'ag-center-content',
            valueGetter: "node.rowIndex + 1",
						// field: "sn",
						width: 25,
						// minWidth: 50, width: 50,
						// cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
						// suppressHeaderMenuButton: true,
						// type: 'rightAligned',
						// editable: true,
					},
					{
						headerName: 'Categories',
						headerGroupComponent: 'HeaderGroupComponent',
						headerClass: 'ag-center-content',
						children: [
							{
								headerName: "Cat A/B",
								headerClass: 'ag-center-content',
								field: "cat.name",
								minWidth: 50, width: 300,
								// cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
							},
							{
								headerName: "Infrastructure Category",
								headerClass: 'ag-center-content',
								field: "infra_cat.category_name",
								minWidth: 50, width: 350,
								// cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
							},
							{
								headerName: "Infrastructure Sub Category",
								headerClass: 'ag-center-content',
								field: "infra_sub_cat.subcategory_name",
								minWidth: 50, width: 350,
								// cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
							},
						]
					},
					{
						headerName: 'Failure Mode',
						headerClass: 'ag-center-content',
						field: "failure_mode.failure_mode",
						minWidth: 50, width: 250,
						// cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
						suppressHeaderMenuButton: true,
						type: 'rightAligned',
						// editable: true,
					},
					{
						headerName: 'Description',
						headerClass: 'ag-center-content',
						field: "description",
						width: 150,
						// cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
						suppressHeaderMenuButton: true,
						// editable: true,
					},
					{
						headerName: 'Remarks',
						headerClass: '',
						field: "remarks",
						width: 100,
						// cellRenderer: (params) => (params.value == 0) ? 'Fail' : 'Pass',
						suppressHeaderMenuButton: true,
						// editable: true,
					},
					{
						headerName: 'QA/QC',
						headerGroupComponent: 'HeaderGroupComponent',
						headerClass: 'ag-qaqc-portion',
						children: [
							{
								headerName: "Date Generated",
								headerClass: 'ag-qaqc-portion',
								field: "date_generated",
								width: 50,
								// cellRenderer: (params) => params.value ? params.value.toString() : '',
							},
							{
								headerName: "Acknowledge By",
								headerClass: 'ag-qaqc-portion',
								field: "qaqc_name",
								width: 50,
								// cellRenderer: (params) => params.value ? params.value.toString() : '',
							},
						]
					},										
					{
						headerName: 'Contractor',
						headerGroupComponent: 'HeaderGroupComponent',
						headerClass: 'ag-contractor-portion',
						children: [
							{
								headerName: "Date Completion",
								headerClass: 'ag-contractor-portion',
								field: "date_completion",
								width: 30,
								// cellRenderer: (params) => params.value ? params.value.toString() : '',
							},
							{
								headerName: "Acknowledge By",
								headerClass: 'ag-contractor-portion',
								field: "contractor_name",
								width: 30,
								// cellRenderer: (params) => params.value ? params.value.toString() : '',
							},
						]
					},
          {
						headerName: 'Status',
						headerClass: '',
						field: "status",
						width: 100,
						// cellRenderer: (params) => (params.value == 0) ? 'Fail' : 'Pass',
						suppressHeaderMenuButton: true,
						// editable: true,
            cellStyle: function(params) {
              var val_status = params.node.data.status;

              // console.log({
              //   "params": params,
              //   "data": params.data,
              //   "val_status": val_status
              // });
              let background = "#FFFFFF"
              if ( val_status === 'APPROVED' ) {
                //_ approved
                background = "#CFF3C0";
              } else if ( val_status === 'REJECTED' ) {
                //_ rejected
                background = "#FC6A6B";
              } else {
                //_ default
              }

              // Return the style object
              return {
                background: background
              };
            }
					},
				],
        headerHeight: 45,
        defaultColDef: {
          flex: 1,
        },
        // groupDefaultExpanded: 1,
        // detailRowHeight: 400,
        // detailRowAutoHeight: false,
        // embedFullWidthRows: false,
        // masterDetail: true,
        // autoSizeStrategy: {
        //   type: 'fitCellContents'
        // },
      }
		},
		edit_selected_punch_item(dataPunchItem = null) {
      this.devMsg(this.oDev.debug, 'edit_selected_punch_item', 'gs')

      this.oModel.qaqc_images = [];

      this.oGrid.selected = {
        punch_item: dataPunchItem,
      };
      this.devMsg(this.oDev.debug, 'this.oGrid.selected')
      this.devMsg(this.oDev.debug, this.oGrid.selected)

      // this.oModel.pvTest_update_string = dataString

      // this.oModel.pvTest_update_string.string_polarity_check = this.convertToggle(dataString.string_polarity_check);

      //_ populate selected string modal fields
      this.oModel.qaqc_item_update.id = dataPunchItem.id;
      this.oModel.qaqc_item_update.sn = dataPunchItem.sn;
      this.oModel.qaqc_item_update.description = dataPunchItem.description;
      this.oModel.qaqc_item_update.cat_id = dataPunchItem.cat.id;
      this.oModel.qaqc_item_update.infra_cat_id = dataPunchItem.infra_cat.id;
      this.oModel.qaqc_item_update.infra_sub_cat_id = dataPunchItem.infra_sub_cat.id;
      this.oModel.qaqc_item_update.failure_mode_id = dataPunchItem.failure_mode.id;
      this.oModel.qaqc_item_update.remarks = dataPunchItem.remarks;
      this.oModel.qaqc_item_update.date_generated = dataPunchItem.date_generated;
      this.oModel.qaqc_item_update.qaqc_name = dataPunchItem.qaqc_name;
      this.oModel.qaqc_item_update.qaqc_acknowledge = dataPunchItem.qaqc_acknowledge;
			this.oModel.qaqc_item_update.qaqc_images = dataPunchItem.qaqc_images;

      this.oModel.qaqc_item_update.date_completion = dataPunchItem.date_completion;
      this.oModel.qaqc_item_update.contractor_name = ( dataPunchItem.contractor_name !== null ) ? dataPunchItem.contractor_name : this.shareData.user.name;
      this.oModel.qaqc_item_update.contractor_acknowledge = dataPunchItem.contractor_acknowledge;
			this.oModel.qaqc_item_update.contractor_images = dataPunchItem.contractor_images;

      this.oModel.qaqc_item_update.status = dataPunchItem.status;
      this.oModel.qaqc_item_update.reject_remarks = dataPunchItem.reject_remarks;

			this.populate_dd_sub_category( dataPunchItem.infra_cat.id, dataPunchItem.infra_sub_cat.id );
			this.selected_cat_ab();

			//_ QAQC - get images from server to be display on the UI
			if ( this.oModel.qaqc_item_update.qaqc_images.length > 0 ) {
				this.oModel.qaqc_item_update.qaqc_images.forEach((e) => {
          e['imageDataSrc'] =  null;
        });

				this.oModel.qaqc_item_update.qaqc_images.forEach((e, index) => {
					let tmp_img_url = e['image']['url'];
					if ( tmp_img_url.substring(0, 1) == '/' ) {
						tmp_img_url = tmp_img_url.substring(1, tmp_img_url.length);
					}

          axios.get(apiDomain + tmp_img_url, { headers: getHeader() })
            .then ( response => {
              if (response.status === 200) {                
                e['imageDataSrc'] = `data:${response.data.data.mime};base64,${response.data.data.image}`;
                this.oModel.qaqc_item_update.qaqc_images.push("");
                this.oModel.qaqc_item_update.qaqc_images.splice(-1);
              }
            })
            .catch ( error => {
              console.log(error.response.status)
            });
        });
			}

			//_ CONTRACTOR - get images from server to be display on the UI
			if ( this.oModel.qaqc_item_update.contractor_images.length > 0 ) {
				this.oModel.qaqc_item_update.contractor_images.forEach((e) => {
          e['imageDataSrc'] =  null;
        });

				this.oModel.qaqc_item_update.contractor_images.forEach((e, index) => {
					let tmp_img_url = e['image']['url'];
					if ( tmp_img_url.substring(0, 1) == '/' ) {
						tmp_img_url = tmp_img_url.substring(1, tmp_img_url.length);
					}

          axios.get(apiDomain + tmp_img_url, { headers: getHeader() })
            .then ( response => {
              if (response.status === 200) {                
                e['imageDataSrc'] = `data:${response.data.data.mime};base64,${response.data.data.image}`;
                this.oModel.qaqc_item_update.contractor_images.push("");
                this.oModel.qaqc_item_update.contractor_images.splice(-1);
              }
            })
            .catch ( error => {
              console.log(error.response.status)
            });
        });
			}

			this.devMsg(this.oDev.debug, 'this.oModel.qaqc_item_update')
      this.devMsg(this.oDev.debug, this.oModel.qaqc_item_update)

			this.modal_show('modal-punch-item-entry');
			// return (image_db + image_ui) > 3;

      // this.devMsg(this.oDev.debug, 'this.oModel.pvTest_update_string')
      // this.devMsg(this.oDev.debug, this.oModel.pvTest_update_string)

      // this.modal_show('modal-pv-test-update-string-entry', 'update', false);
      this.devMsg(this.oDev.debug, '', 'ge')
    },
    modal_show(whichModal, isNew = false) {
      //_ reset fields
      ( isNew ) ? this.reset_punch_item_modal() : '';

      this.$refs[whichModal].show()
    },
    modal_close(whichModal) {
      this.$refs[whichModal].hide();
    },

    reset_punch_item_modal() {
      //_ punch item fields
      // this.oField.dd_infra_category = [  { key: '', value: '-- loading --' } ];
      this.oField.dd_infra_sub_category = [  { key: '', value: '-- please select category --' } ];
      // this.oField.dd_failure_mode = [  { key: '', value: '-- loading --' } ];

      this.oModel.qaqc_item_update.id = null;
      this.oModel.qaqc_item_update.sn = 1;
      this.oModel.qaqc_item_update.description = '';
      this.oModel.qaqc_item_update.cat_id = '';
      this.oModel.qaqc_item_update.infra_cat_id = '';
      this.oModel.qaqc_item_update.infra_sub_cat_id = '';
      this.oModel.qaqc_item_update.failure_mode_id = '';
      this.oModel.qaqc_item_update.remarks = '';
      // this.oModel.qaqc_item_update.date_generated = '';
      // this.oModel.qaqc_item_update.qaqc_name = '';
      this.oModel.qaqc_item_update.qaqc_acknowledge = '';
			this.oModel.qaqc_item_update.qaqc_images = [];

      this.set_created_new_punch_item();

      this.oModel.qaqc_images = [];
    },


    //_ QAQC - image upload & viewer
    handleImageFileUpload_QAQC() {
      let vm = this;
      this.oModel.qaqc_images.push(
        {
          photoFile: {},
          photoPreviewSrc: "",
          photoRemarks: "",
        },
      );
      // console.log(this.$refs.imageFile_QAQC.files[0]);
      this.oModel.qaqc_images.at(-1).photoFile = this.$refs.imageFile_QAQC.files[0];
      // console.log(this.oModel.qaqc_images.at(-1).photoFile);

      var reader = new FileReader();
      reader.onload = function(e) {
        vm.oModel.qaqc_images.at(-1).photoPreviewSrc = e.target.result;
      };

      reader.readAsDataURL(this.oModel.qaqc_images.at(-1).photoFile);
    },
    deletePhoto_QAQC(index){
      this.oModel.qaqc_images.splice(index, 1);
    },    

    //_ CONTRACTOR - image upload & viewer
    handleImageFileUpload_contractor() {
      let vm = this;
      this.oModel.contractor_images.push(
        {
          photoFile: {},
          photoPreviewSrc: "",
          photoRemarks: "",
        },
      );
      // console.log(this.$refs.imageFile_contractor.files[0]);
      this.oModel.contractor_images.at(-1).photoFile = this.$refs.imageFile_contractor.files[0];

      var reader = new FileReader();
      reader.onload = function(e) {
        vm.oModel.contractor_images.at(-1).photoPreviewSrc = e.target.result;
      };

      reader.readAsDataURL(this.oModel.contractor_images.at(-1).photoFile);
    },
    deletePhoto_contractor(index){
      this.oModel.contractor_images.splice(index, 1);
    },   

    //_ DELETE photo from db for qaqc and contractor
		deletePhoto_from_db( what_action='confirmation', image_src='', image_id='', image_idx='' ) {
      //_ rather than creating separated modal for confirmation image deletion for qaqc and contractor, let's just use one
      this.devMsg(this.oDev.debug, 'deletePhoto_from_db', 'gs')

      if ( image_src != '' && image_id != '' ) {
        this.oModal.confirmation_img_deletion.image_id = image_id;
        this.oModal.confirmation_img_deletion.image_idx = image_idx;

        if ( what_action == 'confirm' ) {
          let api_url = apiDomain + 'e_forms/remove_punch_list_qaqc_image_by_id/' + image_id;
          if ( image_src == 'contractor' ) {
            api_url = apiDomain + 'e_forms/remove_punch_list_contractor_image_by_id/' + image_id;
          }
          
          axios
          .post(api_url, { headers: getHeader() })
          // .post(api_url, { headers })
          .then((response) => {
            if (response.status === 200) {
              this.msg_notify_ok('<b>Punch Item Entry Photo Successfully Deleted.</b>');

              if ( image_src == 'contractor') {
                this.oModel.qaqc_item_update.contractor_images.splice(image_idx, 1);
              } else {
                this.oModel.qaqc_item_update.qaqc_images.splice(image_idx, 1);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              // Handle error with response
              this.errorFunction(error, "Punch Item Entry Image Deletion");
            } else {
              // Handle error without response
              this.msg_notify_sembcorp();
            }
          })
          .finally(() => {
            this.modal_close('modal-confirmation')
          });   

        } else if ( what_action == 'cancel' ) {
          this.oModal.confirmation_img_deletion.image_src = '';
          this.oModal.confirmation_img_deletion.image_id = '';
          this.oModal.confirmation_img_deletion.image_idx = '';

          this.$refs['modal-confirmation'].hide();
        } else {
          this.oModal.confirmation_img_deletion.image_src = image_src;
          this.oModal.confirmation_img_deletion.image_id = image_id;
          this.oModal.confirmation_img_deletion.image_idx = image_idx;
          this.$refs['modal-confirmation'].show()
        }
        
      } else {
        this.redErrorNotify("<b>Unable to delete the photo.</b>");
      }
		
      this.devMsg(this.oDev.debug, '', 'ge')
		},

		showLargeImage(imageSrc){
			this.oModal.src_large_img = imageSrc;
			this.oModal.is_visible_large_img = true;
		},


    //_ dropdown list
    selected_cat_ab() {
      // this.devMsg(this.oDev.debug, 'selected_cat_ab', 'gs')

			// this.devMsg(this.oDev.debug, 'this.oField.dd_cat_a_b');
			// this.devMsg(this.oDev.debug, this.oField.dd_cat_a_b);

			// this.devMsg(this.oDev.debug, 'this.oModel.qaqc_item_update.cat_id');
			// this.devMsg(this.oDev.debug, this.oModel.qaqc_item_update.cat_id);

      let selectedKey = ( this.oModel.qaqc_item_update.cat_id !== null ) ? this.oModel.qaqc_item_update.cat_id.toString() : '';
      if ( selectedKey != '' ) {
        let result = this.oField.dd_cat_a_b.filter(obj => {
          return obj.key === selectedKey
        })

				// this.devMsg(this.oDev.debug, 'result');
				// this.devMsg(this.oDev.debug, result);

        this.oModel.qaqc_item_update.cat = result[0].value;
      }

			// this.devMsg(this.oDev.debug, 'this.oModel.qaqc_item_update.cat');
			// this.devMsg(this.oDev.debug, this.oModel.qaqc_item_update.cat);

      // this.devMsg(this.oDev.debug, '', 'ge')
    },

    selected_dd_category() {
      // this.devMsg(this.oDev.debug, 'selected_dd_category', 'gs')

      let selectedKey = this.oModel.qaqc_item_update.infra_cat_id;

      this.devMsg(this.oDev.debug, selectedKey)
      if ( selectedKey !== '' ) {
        this.populate_dd_sub_category(selectedKey);
      }

      // this.devMsg(this.oDev.debug, '', 'ge')
    },

    populate_dd_category() {
      axios
      .get(apiDomain + 'e_forms/categories', { headers: getHeader() })
      .then ( response => {
        if (response.status === 200) {
					// this.devMsg(this.oDev.debug, 'populate_dd_category', 'gs')

          // this.devMsg(this.oDev.debug, 'populate_dd_category: response.data.data')
          // this.devMsg(this.oDev.debug, response.data)

          let tmpResponse = response.data;
          if ( tmpResponse.length > 0 ) {
            this.oField.dd_infra_category = [];
            this.oField.dd_infra_category.push({key: '', value: '-- please select --' })
            tmpResponse.forEach( (entry => {
              this.oField.dd_infra_category.push({key: entry.id, value: entry.category_name })
            }))
          }

          // this.devMsg(this.oDev.debug, 'updated this.oField.dd_infra_category')
          // this.devMsg(this.oDev.debug, this.oField.dd_infra_category)

					// this.devMsg(this.oDev.debug, '', 'ge')
        }
      })
      .catch ( error => {
        console.log(error.response.status);
      });
    },
    populate_dd_sub_category( selectedCategoryId='', selected_value = '' ) {
      axios
      .get(apiDomain + 'e_forms/subcategories/' + selectedCategoryId, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200) {
					// this.devMsg(this.oDev.debug, 'populate_dd_sub_category', 'gs')

          // this.devMsg(this.oDev.debug, 'populate_dd_sub_category: response.data.data')
          // this.devMsg(this.oDev.debug, response.data)

          let tmpResponse = response.data;
          if ( tmpResponse.length > 0 ) {
            this.oField.dd_infra_sub_category = [];
            this.oField.dd_infra_sub_category.push({key: '', value: '-- please select --' })
            tmpResponse.forEach( (entry => {
              this.oField.dd_infra_sub_category.push({key: entry.id, value: entry.subcategory_name })
            }))
          }

          this.oModel.qaqc_item_update.infra_sub_cat_id = selected_value;

          // this.devMsg(this.oDev.debug, 'updated this.oField.dd_infra_sub_category')
          // this.devMsg(this.oDev.debug, this.oField.dd_infra_sub_category)

					// this.devMsg(this.oDev.debug, '', 'ge')
        }
      })
      .catch ( error => {
        console.log(error.response.status);
      });
    },
    populate_dd_failure_mode() {
      axios
      .get(apiDomain + 'e_forms/failure-modes', { headers: getHeader() })
      .then ( response => {
        if (response.status === 200) {
					// this.devMsg(this.oDev.debug, 'populate_dd_failure_mode', 'gs')

          // this.devMsg(this.oDev.debug, 'populate_dd_failure_mode: response.data.data')
          // this.devMsg(this.oDev.debug, response.data)

          let tmpResponse = response.data;
          if ( tmpResponse.length > 0 ) {
            this.oField.dd_failure_mode = [];
            this.oField.dd_failure_mode.push({key: '', value: '-- please select --' })
            tmpResponse.forEach( (entry => {
              this.oField.dd_failure_mode.push({key: entry.id, value: entry.failure_mode })
            }))
          }

          // this.devMsg(this.oDev.debug, 'updated this.oField.dd_failure_mode')
          // this.devMsg(this.oDev.debug, this.oField.dd_failure_mode)

					// this.devMsg(this.oDev.debug, '', 'ge')
        }
      })
      .catch ( error => {
        console.log(error.response.status);
      });
    },

    set_created_new_punch_item() {
      if ( this.oModel.qaqc_item_update.date_generated == '' ) {
        var currentDate = getcurrentDate();
        var localCurrentDate = new Date(currentDate);

        // get current date in yyyy-mm-dd format
        const currentYear = localCurrentDate.getFullYear();
        const currentMonth = String(localCurrentDate.getMonth() + 1).padStart(2, "0");
        const currentDay = String(localCurrentDate.getDate()).padStart(2, "0");

        this.oModel.qaqc_item_update.date_generated = currentYear + "-" + currentMonth + "-" + currentDay;

        this.oModel.qaqc_item_update.qaqc_name = this.shareData.user.name;
      }
    },


    //_ update and saving to db
    check_required_data_by_qaqc() {
			this.devMsg(this.oDev.debug, 'check_required_data_by_qaqc', 'gs')
			
      // this.devMsg(this.oDev.debug, 'this.oModel.qaqc_item_update')
      // this.devMsg(this.oDev.debug, this.oModel.qaqc_item_update)

      // this.devMsg(this.oDev.debug, 'this.oModel.qaqc_images')
      // this.devMsg(this.oDev.debug, this.oModel.qaqc_images)

			var checker = false;
      var checker_images = false;
			if (
        // !this.oModel.qaqc_item_update.sn ||
				!this.oModel.qaqc_item_update.description ||
				!this.oModel.qaqc_item_update.cat_id ||
				!this.oModel.qaqc_item_update.infra_cat_id ||
				!this.oModel.qaqc_item_update.infra_sub_cat_id ||
				!this.oModel.qaqc_item_update.failure_mode_id ||
        this.oModel.qaqc_item_update.qaqc_acknowledge == 0
			) {
				// if (this.oModel.qaqc_item_update.sn == '') {
				// 	this.redErrorNotify(
				// 		"<b>Invalid Input : Serial Number is a Mandatory Field.</b>"
				// 	);
				// } else 
        if (this.oModel.qaqc_item_update.description == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Description is a Mandatory Field.</b>"
					);
				} else if (this.oModel.qaqc_item_update.cat_id == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Category is a Mandatory Field.</b>"
					);
				} else if (this.oModel.qaqc_item_update.infra_cat_id == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Infrastructure Category is a Mandatory Field.</b>"
					);
				} else if (this.oModel.qaqc_item_update.infra_sub_cat_id == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Infrastructure Sub Category is a Mandatory Field.</b>"
					);
				} else if (this.oModel.qaqc_item_update.failure_mode_id == '') {
					this.redErrorNotify(
						"<b>Invalid Input : Failure Mode is a Mandatory Field.</b>"
					);
				} else if (this.oModel.qaqc_item_update.qaqc_acknowledge == 0) {
					this.redErrorNotify(
						"<b>Submitting punch item required your acknowledgement and consent.</b>"
					);
				} else {
					this.redErrorNotify(
						"<b>Invalid Input : Please fill in all the Mandatory Fields.</b>"
					);
				}
			} else {
				checker = true;
			}

      if ( this.oModel.qaqc_images.length > 0 || this.oModel.qaqc_item_update.qaqc_images.length > 0 ) {
        checker_images = true;
      } else {
        this.redErrorNotify( "<b>Invalid Input : Photo is a Mandatory Field.</b>" );
      }

			if (checker && checker_images) {
				this.devMsg(this.oDev.debug, 'passed all checks')

				// this.obj_new_entry.submit_clicked = true;
				// this.obj_new_entry.isSubmissionWarningVisible = true;
			}

			this.devMsg(this.oDev.debug, '', 'ge')

			return (checker && checker_images);
		},
    update_punch_item_by_qaqc() {
      this.devMsg(this.oDev.debug, 'update_punch_item_by_qaqc', 'gs')

      if (this.check_required_data_by_qaqc()) {
        this.$refs['modal-loading-in-progress'].show();

        let api_url = apiDomain + 'e_forms/create_punch_list_items/' + this.$route.params.id;
        if (this.oModel.qaqc_item_update.id != null) {
          this.devMsg(this.oDev.debug, 'masuk sini ga seh')

          // api_url = apiDomain + 'e_forms/update_punch_list_items_by_qaqc/' + this.$route.params.id;
          api_url = apiDomain + 'e_forms/update_punch_list_items_by_qaqc';  
        }     
        
        let tmpModel = this.oModel.qaqc_item_update;

        tmpModel.qaqc_acknowledge = this.convertToggle(this.oModel.qaqc_item_update.qaqc_acknowledge, true);

        //_ saved images, try to remove the imageDataSrc
        // if ( tmpModel.qaqc_images.length > 0 ) {
        //   tmpModel.qaqc_images.forEach( (e => {
        //     delete e.imageDataSrc
        //   }))
        // }

        // delete tmpModel.qaqc_images;

        //_ new images
        if ( this.oModel.qaqc_images.length > 0 ) {
          // tmpModel.qaqc_images = [];
          this.oModel.qaqc_images.forEach( (e => {
            tmpModel.qaqc_images.push(e);
          }))
        }
        // tmpModel.qaqc_images = this.oModel.qaqc_images;


        // this.devMsg(this.oDev.debug, 'tmpModel')
        // this.devMsg(this.oDev.debug, tmpModel)        
        
        let dbModel = { punchListItems: [] }
        dbModel.punchListItems.push(tmpModel);

        this.devMsg(this.oDev.debug, 'dbModel')
        this.devMsg(this.oDev.debug, dbModel)   

        let formData = jsonFormData(dbModel);
        // formData.append("_method", "put");

        // this.devMsg(this.oDev.debug, 'formData')
        // this.devMsg(this.oDev.debug, formData)   

        axios
          .post(api_url, formData, { headers: getHeader() })
          .then((response) => {
            if (response.status === 200) {
              this.msg_notify_ok('<b>Punch Item Entry Successfully Created.</b>');

              this.$router.go(0);
            }
          })
          .catch((error) => {
            if (error.response) {
              // Handle error with response
              this.errorFunction(error, "Punch Item Entry Creation");
            } else {
              // Handle error without response
              this.msg_notify_sembcorp();
            }
          })
          .finally(() => {
            this.$refs['modal-loading-in-progress'].hide();
            this.modal_close('modal-punch-item-entry')
          });             
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },


    check_required_data_by_contractor() {
			this.devMsg(this.oDev.debug, 'check_required_data_by_contractor', 'gs')
			
      this.devMsg(this.oDev.debug, 'this.oModel.qaqc_item_update')
      this.devMsg(this.oDev.debug, this.oModel.qaqc_item_update)

      // this.devMsg(this.oDev.debug, 'this.oModel.contractor_images')
      // this.devMsg(this.oDev.debug, this.oModel.contractor_images)

			var checker = false;
      var checker_images = false;
			if (
        !this.oModel.qaqc_item_update.date_completion ||
        this.oModel.qaqc_item_update.contractor_acknowledge == 0
			) {
        
				if (this.oModel.qaqc_item_update.date_completion === null) {
					this.redErrorNotify(
						"<b>Invalid Input : Completion Date is a Mandatory Field.</b>"
					);
				} else if (this.oModel.qaqc_item_update.contractor_acknowledge == 0) {
					this.redErrorNotify(
						"<b>Submitting punch item required your acknowledgement and consent.</b>"
					);
				} else {
					this.redErrorNotify(
						"<b>Invalid Input : Please fill in all the Mandatory Fields.</b>"
					);
				}
			} else {
				checker = true;
			}

      if ( this.oModel.contractor_images.length > 0 || this.oModel.qaqc_item_update.contractor_images.length > 0 ) {
        checker_images = true;
      } else {
        this.redErrorNotify( "<b>Invalid Input : Photo is a Mandatory Field.</b>" );
      }

			if (checker && checker_images) {
				this.devMsg(this.oDev.debug, 'passed all checks')

				// this.obj_new_entry.submit_clicked = true;
				// this.obj_new_entry.isSubmissionWarningVisible = true;
			}

			this.devMsg(this.oDev.debug, '', 'ge')

			return (checker && checker_images);
		},    
    update_rectification_by_contractor() {
      this.devMsg(this.oDev.debug, 'update_rectification_by_contractor', 'gs')

      if (this.check_required_data_by_contractor()) {
        this.$refs['modal-loading-in-progress'].show();

        let api_url = apiDomain + 'e_forms/update_punch_list_items_by_contractor';

        let tmpModel = {
          id: this.oModel.qaqc_item_update.id,
          date_completion: this.oModel.qaqc_item_update.date_completion,
					contractor_name: this.oModel.qaqc_item_update.contractor_name,
          contractor_images: [],
					contractor_acknowledge: this.convertToggle(this.oModel.qaqc_item_update.contractor_acknowledge, true),
        };

        //_ new images
        if ( this.oModel.contractor_images.length > 0 ) {
          // tmpModel.contractor_images = [];
          this.oModel.contractor_images.forEach( (e => {
            tmpModel.contractor_images.push(e);
          }))
        }

        // this.devMsg(this.oDev.debug, 'tmpModel')
        // this.devMsg(this.oDev.debug, tmpModel)    

        let dbModel = { punchListItems: [] }
        dbModel.punchListItems.push(tmpModel);

        this.devMsg(this.oDev.debug, 'dbModel')
        this.devMsg(this.oDev.debug, dbModel)   

        let formData = jsonFormData(dbModel);

        axios
          .post(api_url, formData, { headers: getHeader() })
          .then((response) => {
            if (response.status === 200) {
              this.msg_notify_ok('<b>Contractor - Updated Punch Item Entry Successfully.</b>');

              this.$router.go(0);
            }
          })
          .catch((error) => {
            if (error.response) {
              // Handle error with response
              this.errorFunction(error, "Contractor - Punch Item Entry Update");
            } else {
              // Handle error without response
              this.msg_notify_sembcorp();
            }
          })
          .finally(() => {
            this.$refs['modal-loading-in-progress'].hide();
            this.modal_close('modal-punch-item-entry')
          });          
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },



    //_ APPROVAL
    approval_process() {
      this.devMsg(this.oDev.debug, 'approval_process', 'gs')

      this.oModel.approval.remarks = '';
      this.$refs['modal-punch-item-approval'].show();

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    approval_execute( theAction='' ) {
      this.devMsg(this.oDev.debug, 'approval_execute', 'gs')

      this.devMsg(this.oDev.debug, theAction)
      this.devMsg(this.oDev.debug, this.oModel.qaqc_item_update.id)
      this.devMsg(this.oDev.debug, this.oModel.approval.remarks)

      let checker = true;

      let api_url = apiDomain + 'e_forms/approve_punch_list_items/' + this.oModel.qaqc_item_update.id; 
      if ( theAction == 'reject' ) {
        api_url = apiDomain + 'e_forms/reject_punch_list_items/' + this.oModel.qaqc_item_update.id; 

        if (this.oModel.approval.remarks === '') {
					this.redErrorNotify( "<b>Invalid Input : Remarks is a Mandatory Field.</b>" );

          checker = false;
				} 
      } 

      if ( checker ) {
				this.$refs['modal-loading-in-progress'].show();

        let formData = jsonFormData( {reject_remarks: this.oModel.approval.remarks} );

        axios
          .post(api_url, formData, { headers: getHeader() })
          .then((response) => {
            if (response.status === 200) {
              this.msg_notify_ok('<b>Approval submitted Successfully.</b>');
               //this.$router.go(0);

              ///*
              console.log('this.subData')
              console.log(this.subData)

              if ( theAction == 'approve' ) {
                //_ is there any un-Approved entry beside the selected one that being approve right now ?
                //  if there is, then don't do the closure
                this.process_check_closure();
              }
              //*/        
            } 
          })
          .catch((error) => {
            if (error.response) {
              // Handle error with response
              this.errorFunction(error, "Approval submmission");
            } else {
              // Handle error without response
              this.msg_notify_sembcorp();
            }
          })
          .finally(() => {
            this.$refs['modal-loading-in-progress'].hide();
            this.$refs['modal-punch-item-approval'].hide();
          });
      }
      
      this.devMsg(this.oDev.debug, '', 'ge')
    },
    process_check_closure() {
      let bClosure = false;

      let arrNotApproved = this.subData.filter(element => (element.status !== 'APPROVED' && element.id !== this.oModel.qaqc_item_update.id));
      console.log('arrNotApproved')
      console.log(arrNotApproved)

      //_ since all approved then proceed with closure
      if ( arrNotApproved.length == 0 ) bClosure = true;

      //_ closure process
      if ( bClosure ) {
        //_ we need contractor info, and it also MUST be the latest date
        let dataPunchItems = cloneDeep(this.subData);

        // sorting it decrase (latest to oldest)
        dataPunchItems.sort((a, b) => new Date(b.date_completion) - new Date(a.date_completion));

        // get the 1st entry, since it's going to be the latest and use it for closure by contractor/epc
        let model_closure_epc = {
          contractor_name: dataPunchItems[0].contractor_name,
          // contractor_signature_image: '',
          contractor_acknowledge: 1,
          contractor_date: dataPunchItems[0].date_completion,
          contractor_remarks: '',
        }

        //_ we also need qaqc info that make the last approval
        let model_closure_qaqc = {
          qaqc_name: this.shareData.user.name,
          // qaqc_signature_image: '',
          qaqc_acknowledge: 1,
          qaqc_date: moment().format('YYYY-MM-DD'),
          qaqc_remarks: '',
        }

        this.process_closure_epc(model_closure_epc, model_closure_qaqc);

      } else {
        this.$router.go(0);
      }
    },
    process_closure_epc( model_closure_epc = null, model_closure_qaqc = null ) {
      let api_url = apiDomain + 'e_forms/punch_list_acknowledge_by_contractor/' + this.$route.params.id;

      console.log('model_closure_epc');
      console.log(model_closure_epc);
      console.log(api_url);

      let formData = jsonFormData(model_closure_epc);
      axios
      .post(api_url, formData, { headers: getHeader() })
      .then((response) => {
        if (response.status === 200) {
          this.process_closure_qaqc(model_closure_qaqc);
        }
      })
      .catch((error) => {
        if (error.response) {
          // Handle error with response
          this.errorFunction(error, "Contractor - Punchlist Closure Entry Update");
        } else {
          // Handle error without response
          this.msg_notify_sembcorp();
        }
      });  

      
    },
    process_closure_qaqc( model_closure_qaqc = null ) {
      let api_url = apiDomain + 'e_forms/punch_list_acknowledge_by_qaqc/' + this.$route.params.id;

      console.log('model_closure_qaqc');
      console.log(model_closure_qaqc);
      console.log(api_url);

      let formData = jsonFormData(model_closure_qaqc);
      axios
      .post(api_url, formData, { headers: getHeader() })
      .then((response) => {
        if (response.status === 200) {
          this.$router.go(0);
        }
      })
      .catch((error) => {
        if (error.response) {
          // Handle error with response
          this.errorFunction(error, "QA/QC - Punchlist Closure Entry Update");
        } else {
          // Handle error without response
          this.msg_notify_sembcorp();
        }
      });
    },

  },
}
</script>


<!-- ag-grid related -->
<style>
.ag-qaqc-portion {
  background-color: #dce6f1;
  justify-content: center;
}

.ag-contractor-portion {
  background-color: #fde9d9;
  justify-content: center;
}

.ag-center-content {
  justify-content: center;
}

.ag-header-cell-label .ag-header-cell-text {
  white-space: pre-wrap !important;
}

.column-2 {
  background-color: #c9daf8;
  /* light blue */
}

.column-3 {
  background-color: #d9ead3;
  /* light green */
}

.ag-root-wrapper-body.ag-layout-normal {
  height: 700px
}

.ag-cell {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

label {
  font-weight: normal !important;
}

.bg-default-dashboard {
  background-color: #082A2F;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.div-percent-bar {
  display: inline-block;
  height: 100%;
  position: relative;
  z-index: 0;
}

.div-percent-value {
  position: absolute;
  padding-left: 4px;
  font-weight: bold;
  font-size: 13px;
  z-index: 100;
}

.div-outer-div {
  display: inline-block;
  height: 100%;
  width: 100%;
}

.ag-menu {
  z-index: 200;
}

.toolbar button {
  margin-left: 5px;
  margin-right: 5px;
  padding: 2px;
}
</style>

<!-- form element -->
<style scoped>
/deep/ hr {
  background-color: white;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

/deep/ .form-control {
  background-color: #2C545A;
  border-color: #2C545A;
  color: white;

  &:focus {
    background-color: #2C545A;
    border-color: #2C545A;
    /* color: white; */
  }

  &::placeholder {
    color: rgb(163, 163, 163);
  }
}

/deep/ .form-control {
  &:focus {
    &::placeholder {
      color: rgb(163, 163, 163);
    }
  }
}

/deep/ .form-control,
select option {
  color: #ffffff;
}

/deep/ .form-control:disabled {
  background-color: #2c545a;
  border-color: #2c545a;
  color: #888888;
}

/deep/ .input-group-text {
  background-color: #2C545A;
  color: white;

  &:focus {
    background-color: #2C545A;
    border-color: #1D4147;
    color: white;
  }
}

/deep/ input::-webkit-input-placeholder {
  color: #fff;
}

/deep/ input::-moz-input-placeholder {
  color: #fff;
}

/deep/ input::-ms-input-placeholder {
  color: #fff;
}

/deep/ .el-input .el-input__inner {
  background-color: #2C545A;
  color: #fff;
  border: 0px;
  border-radius: 10px;
  padding-top: 3px;
  padding-bottom: 2px;

  /* &::placeholder {
    color: white;
  } */
}

/deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #23504e;
}

/deep/ .el-select-dropdown {
  background-color: #306b74;
  margin: 0px;
}

/deep/ .el-select-dropdown__item {
  color: white;
  background-color: #183034;

  ::hover {
    background-color: #2C545A
  }

}

/deep/ .el-select {
  .el-input .el-input__inner {
    &::placeholder {
      color: white;
    }
  }

}

/deep/ .el-select__input {
  color: white;
  background-color: #2C545A;
}

/deep/ .el-select__input.hover,
.el-select__input:hover {
  background-color: #23504e;
}
</style>

<!-- modal -->
<style scoped>
/deep/ .modal-content {
  background-color: #306b74 !important;
}

/deep/ .modal-body {
  background-color: #306b74 !important;
}

/deep/ .modal-row-header {
  padding-bottom: 20px;
}

/deep/ .modal-row-category {
  padding-top: 5px;
  padding-bottom: 0px;
}

/deep/ .punch_item_note {
  color: #9d9d9d;
  font-size: 14px;
}

/deep/ .punch_item_consent {
  color: #ffffff;
  font-size: 14px;
}

</style>

<!-- tabs -->
<style scoped>
/deep/ .tab-content {
  padding: 10px;
}

/deep/ .card-footer {
  /* padding: 0.5rem 0.5rem; */
  padding-bottom: 15px;
  background-color: #306b74;
  border-top: 1px solid rgba(0, 0, 0, .05);
}
</style>

<!-- dropdown action menu -->
<style scoped>
/deep/ .btn-dark,
.btn-dark:hover {
  color: #fff;
  background-color: #2c545a;
  border-color: #2c545a;
}

/deep/ .dropdown-menu {
  background-color: #23444a !important;
  border: 1px solid #ffffff;
}

/deep/ .dropdown-item {
  &:hover {
    background-color: #3a656b !important;
    color: #ffffff;
  }

  span {
    padding-left: 8px;
    vertical-align: super;
  }
}
</style>